import { ScriptTab } from './types';

export const tabs: ScriptTab[] = ['basic', 'translations'];
export const DEFAULT_SCRIPT_TAB: ScriptTab = 'basic';
